const FiguresTooltip = props => {
    const {
        date,
        title,
        inFlow,
        roof,
        bottom,
        type = '',
        inflowCharacter,
        flowRate,
        fluid,
        debit,
        perforatingDate,
    } = props;

    return (
        <div className="flex w-64 flex-col">
            <div className="flex items-center">
                <span>{`Интервал ПГИ от ${date}`}</span>
            </div>

            <div className="flex items-center justify-between">
                <span>{title}</span>
                {inFlow !== undefined ? <span>{inFlow === 1 ? 'притока' : 'поглощения'}</span> : null}
                {type === 'perforation' ? <span>{perforatingDate}</span> : null}
            </div>

            <div className="flex items-center justify-between">
                <span>Отн.</span>
                {roof ? (
                    <span>
                        {`${roof.toFixed(2)} - ${bottom.toFixed(2)}`} ({(bottom - roof).toFixed(2)})
                    </span>
                ) : (
                    <span>{bottom.toFixed(2)}</span>
                )}
            </div>

            {type === 'filtration' ? (
                <div className="flex items-center justify-between">
                    <span>Характер притока</span>
                    <span>{inflowCharacter || 'Нет данных'}</span>
                </div>
            ) : null}

            {type === 'filtration' && debit && debit !== 0 ? (
                <div className="flex items-center justify-between">
                    <span>{inFlow === 1 ? 'Дебит' : 'Расход'} интервала</span>
                    <span>{debit.toFixed(2)} м3/сут</span>
                </div>
            ) : null}

            {type === 'filtration' && flowRate ? (
                <div className="flex items-center justify-between">
                    <span>{inFlow === 1 ? 'Дебит' : 'Расход'} суммарного</span>
                    <span>{flowRate.toFixed(1)}</span>
                </div>
            ) : null}

            {fluid ? (
                <div className="flex items-center justify-between">
                    <span>Состав флюида</span>
                    <span>{fluid}</span>
                </div>
            ) : null}
        </div>
    );
};

export default FiguresTooltip;
